import { masker } from './masker';

const emailMask = masker({
  masked: {
    mask: /^\S*@?\S*$/,
    prepareChar: (value: string) => {
      const charOutOfAsciiTable = /([^\x2D-\x5F\x61-\x7A])/g;
      return value.normalize('NFD').replace(charOutOfAsciiTable, '');
    },
    transform: (value: string) => {
      return emailMask.unmask(value);
    },
    maskDefault: (value: string) => {
      return emailMask.mask(value);
    },
  },
});

export { emailMask };
